/* eslint-disable react/no-danger */
import React from 'react';
import classnames from 'classnames';
import styles from './cigar-bar.module.scss';
import { Countdown } from '../../../../web-app-shell/src/components/countdown/countdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CigarBar = function CigarBar(_ref) {
  var className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      countdown = _ref.countdown,
      _ref$showDays = _ref.showDays,
      showDays = _ref$showDays === void 0 ? false : _ref$showDays;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(className, styles.container),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("p", {
        className: styles.title,
        children: title.replace(/\*{2}(.*?)\*{2}/g, '$1')
      }), description && /*#__PURE__*/_jsx("p", {
        className: styles.description,
        children: description.replace(/\*{2}(.*?)\*{2}/g, '$1')
      })]
    }), /*#__PURE__*/_jsx(Countdown, {
      show: true,
      countdown: countdown,
      theme: "white",
      variant: "sm",
      className: styles.countdownContainer,
      showDays: showDays
    })]
  });
};